"use client";

import mixpanel from "mixpanel-browser";

import { MIXPANEL_ACCESS_KEY } from "@/config/env";

let initialized = false;

export function initMixpanel(): boolean {
  if (initialized) return true;
  if (typeof window === "undefined") return false;
  if (!MIXPANEL_ACCESS_KEY) return false;
  mixpanel.init(MIXPANEL_ACCESS_KEY, { persistence: "localStorage" });
  initialized = true;
  return true;
}

export function isMixpanelReady(): boolean {
  return initialized;
}

export function mixpanelIdentify(distinctId: string | number): void {
  if (!initialized) return;
  mixpanel.identify(String(distinctId));
}

export function mixpanelReset(): void {
  if (!initialized) return;
  mixpanel.reset();
}

export function mixpanelTrackPageview(page: string): void {
  if (!initialized) return;
  mixpanel.track_pageview({ page });
}

export function mixpanelTrack(event: string, properties?: Record<string, unknown>): void {
  if (!initialized) return;
  mixpanel.track(event, properties);
}
